import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, IconButton, Menu, MenuItem, Modal } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import classNames from "classnames/bind";
import ButtonCustom from "components/ButtonCustom";
import CONTAINER from "consts/responsive";
import ROUTERS_PATHS from "consts/router-paths";
import Icons from "consts/svgIcons";
import useAuth from "contexts/useAuth";

import SearchComponent from "pages/User/Dashboard/SearchSection/components/SearchComponent";
import * as React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGetReduxUrlIdState } from "redux/categoriesUrl/categoriesUrl";
import { useGetInputValue } from "redux/searchText/searchText";
import { useGetUserState } from "redux/user/userSlice";
import useGetListCateGoryUserSide from "resources/userSide/home";
import { isNumber } from "lodash";
import SearchSection from "pages/User/Dashboard/SearchSection";
import styled from "@emotion/styled";
import clsx from "clsx";
import styles from "./styles.module.scss";

const cx = classNames.bind(styles);

const StyledMenu = styled((props: any) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    width: 80,
    marginLeft: 8,
    "& .MuiMenu-list": {
      padding: "0px 5px 0px 5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
}));

function Header() {
  const { logout, role } = useAuth();
  const refHeader = React.useRef<any>(null);
  const { list: dataCategory, isLoading } = useGetListCateGoryUserSide();
  const IdUrlToRedux = useGetReduxUrlIdState();
  const { subCategoriesId, categoriesId, isCheckTopic, majorVersion, minorVersion, arrticleId } = IdUrlToRedux;
  const { isDisplayHeaderSearch } = useGetInputValue();
  const refAllCategory = React.useRef<HTMLInputElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  const [idExpanded, setIdExpanded] = React.useState<string>("");
  const [slugUrlSub, setSlugUrlSub] = React.useState<string>("");
  const [openSearch, setOpenSearch] = React.useState<boolean>(false);
  const [openSearchMobile, setOpenSearchMobile] = React.useState<boolean>(false);

  const [isOpen, setOpen] = React.useState<boolean>(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openMenu, setOpenMenu] = React.useState<boolean>(false);

  const location = useLocation();
  const queryParams = Object.fromEntries(new URLSearchParams(location.search));
  const { previewTopic } = queryParams as any;
  const user = useGetUserState();

  const handleCloseUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorElUser(null);
  };

  const handleLogout = (event: React.MouseEvent<HTMLElement>) => {
    if (previewTopic) return;
    handleCloseUserMenu(event);
    logout();
  };

  const navigate = useNavigate();

  const handleOpenDrawer = () => {
    setOpen(true);
  };

  const handleOpenSearchDrawer = () => {
    setOpenSearchMobile(true);
  };

  const handleChangeItems = (slug: string) => {
    if (idExpanded === slug) {
      setIdExpanded("");
    } else {
      setIdExpanded(slug);
    }
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const handleClose = () => {
    setOpenMenu(false);
    setAnchorEl(null);
  };

  const pageTypeValue = React.useMemo(() => {
    if (location) {
      const { pathname } = location;
      if (!pathname) return "";

      if (pathname.includes("dashboard")) return "home";
      if (dataCategory) {
        const pathArr = pathname.split("/");
        const resultItem = pathArr?.pop() || "";
        const findSlug = dataCategory.find((item) => item.slugUrl === resultItem);
        if (findSlug) return "sub-category";
      }

      if (pathname.includes("topic")) return "topics";
    }

    return "";
  }, [location, dataCategory]);

  React.useEffect(() => {
    const { search, pathname } = location;
    if (pathname && dataCategory) {
      const pathArr = pathname.split("/");
      const resultItem = pathArr?.pop() || "";
      const findSlug = dataCategory.find((item) => item.slugUrl === resultItem);
      if (findSlug) {
        setIdExpanded(resultItem);
        const slug = search.split("=")[1];
        setSlugUrlSub(slug);
      }
    }
  }, [location, dataCategory]);

  React.useEffect(() => {
    if (!categoriesId) return;
    setIdExpanded(categoriesId);
  }, [categoriesId]);

  const isDashboard = React.useMemo(() => {
    return location.pathname.includes("dashboard");
  }, [location.pathname]);

  const isAdmin = React.useMemo(() => {
    return isCheckTopic;
  }, [isCheckTopic]);

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} className={styles.header} ref={refHeader}>
      {isAdmin && ["Administrator", "Editor"].includes(role) && (
        <Box
          className={styles.textActionMobie}
          sx={{
            position: "fixed",
            top: "70px",
            right: "20px",
            display: "flex",
            background: "#ffffff",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0px 3px 3px 0px #00000017 !important",
          }}
          onClick={
            previewTopic
              ? () => {}
              : () =>
                  navigate(
                    `${ROUTERS_PATHS.CREATE_TOPIC}/${arrticleId}${
                      isNumber(majorVersion) && isNumber(minorVersion) ? `?majorVersion=${majorVersion}&minorVersion=${minorVersion}` : ""
                    }`
                  )
          }
        >
          <Icons.EditTopicsIcon />
          {/* <Typography
            sx={{
              marginLeft: '5px',
              fontSize: '12px',
              fontWeight: '400',
              color: '#427BE9'
            }}
          >
            Edit
          </Typography> */}
        </Box>
      )}
      <Box sx={{ ...CONTAINER }} className={styles.container}>
        <Toolbar disableGutters className={styles.toolbar}>
          <Box display="flex" alignItems="center" justifyContent="space-between" className={cx("tool-bar-wrapper")}>
            <div
              id="logo-container"
              className={cx("logoContainer", {
                hiddenLogo: !isDisplayHeaderSearch && openSearch && isDashboard ? false : openSearch,
              })}
            >
              <Icons.BuildcorpLogoWhite className={styles.logoIcon} onClick={previewTopic ? () => {} : () => navigate(ROUTERS_PATHS.DASHBOARD)} />
            </div>
            <IconButton
              onClick={() => {
                setOpenSearch(true);
              }}
              className={styles.displaySearch}
              sx={{
                display: !openSearch && isDisplayHeaderSearch ? "flex" : "none",
                alignItems: "center",
                "@media (max-width: 900px)": {
                  display: isDashboard && !isDisplayHeaderSearch ? "none" : !openSearch ? "flex" : "none",
                },
                '@media print': {
                  display: 'none !important',
                }
              }}
            >
              <Icons.SearchIconWhite sx={{ marginRight: "5px", color: "#8B8B8B" }} />
            </IconButton>
            <Box
              id="search-box-container-header"
              className={cx("searchSectionHeader", "searchBoxScroll")}
              sx={{
                display: openSearch && isDisplayHeaderSearch ? "flex" : "none",
                transition: "all 0.1s ease-in-out",
                "@media (max-width: 900px)": {
                  display: isDisplayHeaderSearch && openSearch ? "flex" : openSearch && !isDashboard ? "flex" : "none",
                },
              }}
            >
              <SearchComponent
                handleClear={() => {
                  setOpenSearch(false);
                }}
                pageType={pageTypeValue}
              />
            </Box>
          </Box>
          <Box 
            alignItems="center" 
            component="div" 
            className={styles.userContainer}
            sx={{
              '@media print': {
                display: 'none !important',
              }
            }}
          >
            {isAdmin && ["Administrator", "Editor"].includes(role) && (
              <Typography
                className={clsx(styles.menuHeader, styles.userContainer)}
                sx={{ marginRight: "10px" }}
                onClick={
                  previewTopic
                    ? () => {}
                    : () =>
                        navigate(
                          `${ROUTERS_PATHS.CREATE_TOPIC}/${arrticleId}${
                            isNumber(majorVersion) && isNumber(minorVersion) ? `?majorVersion=${majorVersion}&minorVersion=${minorVersion}` : ""
                          }`
                        )
                }
              >
                Edit this topic
              </Typography>
            )}
            {["Administrator", "Editor"].includes(role) && (
              // <Typography
              //   className={styles.menuHeader}
              //   sx={{ marginRight: '10px' }}
              //   onClick={previewTopic ? () => {} : () => navigate(ROUTERS_PATHS.ADMIN_DASHBOARD)}>
              //   Dashboard
              // </Typography>
              <a className={styles.menuHeader} style={{ color: "#fff", textDecoration: "none" }} href={ROUTERS_PATHS.ADMIN_DASHBOARD}>
                Dashboard
              </a>
            )}
            <Box sx={{ alignItems: "center" }} className={styles.userContainer}>
              <Typography sx={{ color: "#69BE28" }} className={styles.menuHeader}>
                {user?.displayName}
              </Typography>
              <IconButton sx={{ padding: 0, marginLeft: "15px", width: 8 }} onClick={(e: any) => handleOpenMenu(e)}>
                <ExpandMoreIcon sx={{ color: "white", float: "right" }} />
              </IconButton>
            </Box>
            <StyledMenu
              style={{
                borderRadius: "6px !important",
              }}
              id="basic-menu"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleClose}
            >
              <MenuItem>
                <Typography className={styles.menuHeader} color="#9E9E9E ," onClick={handleLogout}>
                  Log out
                </Typography>
              </MenuItem>
            </StyledMenu>
          </Box>
          <Box component="div" className={styles.userContainerSmall}>
            <Icons.BgIconListWhite onClick={handleOpenDrawer} />
          </Box>

          <Modal open={isOpen} sx={{ zIndex: 999999 }}>
            <Box className={styles.menuContainer}>
              <Box sx={{ paddingBottom: "2px" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box className={styles.textActionMobie}>
                    <h2 style={{ marginLeft: "15px", fontSize: "16px" }}>{user?.displayName}</h2>
                  </Box>

                  <ClearIcon className={styles.closeIcon} onClick={() => setOpen(false)} />
                </Box>

                <h2 ref={refAllCategory} id="a" style={{ marginLeft: "15px", fontSize: "16px" }}>
                  All Categories
                </h2>

                <Box
                  className={styles.content}
                  sx={{
                    maxHeight: window.innerHeight - 60,
                    overflowY: "scroll",
                  }}
                >
                  <Box sx={{ paddingBottom: "100px" }}>
                    {(dataCategory || []).map((item: any) => {
                      return (
                        <Accordion
                          key={item?.id}
                          expanded={idExpanded === item?.slugUrl}
                          onChange={(e) => handleChangeItems(item?.slugUrl)}
                          className="accordion"
                          sx={{
                            "&.Mui-expanded": { margin: "0 !important" },
                            "&.MuiAccordion-root": {
                              boxShadow: "none",
                              position: "unset",
                              borderBottom: "1px solid #dedede",
                            },
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={idExpanded === item?.slugUrl ? styles.titleItemActive : styles.titleItem}
                          >
                            <Typography
                              sx={{
                                fontWeight: idExpanded === item?.slugUrl ? "700" : "400",
                                fontSize: "14px",
                              }}
                            >
                              {item.ordinalNumber}
                              &nbsp;-&nbsp;{item.name}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails
                            sx={{
                              background: "#EDF0EA",
                              marginTop: "-10px",
                              paddingLeft: "23px",
                            }}
                          >
                            {(item?.subCategories || []).map((sub: any) => {
                              return (
                                <Link
                                  key={sub?.id}
                                  to={`${ROUTERS_PATHS.SUBCATEGORIES}?subId=${sub.ordinalNumber}`.replace(":slugUrl", item.slugUrl)}
                                  style={{
                                    textDecoration: "none",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: slugUrlSub === sub.ordinalNumber || subCategoriesId === sub.id ? "#69be28" : "#8C8C8C",
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      marginBottom: "8px",
                                      padding: "5px 0",
                                      marginLeft: "10px",
                                    }}
                                    onClick={() => setOpen(false)}
                                  >
                                    {sub.ordinalNumber ? `${sub.ordinalNumber} - ${sub.name}` : sub.name}
                                  </Typography>
                                </Link>
                              );
                            })}
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                  </Box>

                  <Box className={styles.boxButtonMobie}>
                    <ButtonCustom
                      color="info"
                      sx={{
                        borderRadius: "8px !important",
                        width: "120px !important",
                        fontSize: "16px",
                        backgroundColor: "#69be28",
                        color: "#fff !important",
                        border: "none !important",
                      }}
                      onClick={() => navigate(ROUTERS_PATHS.ADMIN_DASHBOARD)}
                    >
                      Dashboard
                    </ButtonCustom>
                    <ButtonCustom
                      variant="text"
                      color="info"
                      className={styles.btnLogoutMobie}
                      sx={{
                        borderRadius: "8px !important",
                        width: "120px !important",
                        fontSize: "16px",
                        backgroundColor: "#1b242a",
                        color: "#fff !important",
                        border: "none !important",
                      }}
                      onClick={handleLogout}
                    >
                      Log out
                    </ButtonCustom>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Modal>

          <Modal open={openSearchMobile} sx={{ zIndex: 999999 }}>
            <Box sx={{ paddingRight: "15px" }} className={styles.menuContainer}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box className={styles.textActionMobie}>
                  <h2 style={{ marginLeft: "15px", fontSize: "16px" }}>{user?.displayName}</h2>
                </Box>

                <ClearIcon className={styles.closeIcon} onClick={() => setOpenSearchMobile(false)} />
              </Box>
              <SearchComponent pageType="topics" />
            </Box>
          </Modal>
        </Toolbar>
      </Box>
    </AppBar>
  );
}
export default Header;
